module.exports = __webpack_public_path__ + "fonts/HarmonyOS_Sans_SC_Bold.91e289cf.ttf";